/* eslint-disable react-hooks/exhaustive-deps */
import {useFormik} from 'formik'
import * as Yup from 'yup'
import React, {useEffect, FC, useState, useMemo} from 'react'
import {Button, FormControl, FormLabel, Modal} from 'react-bootstrap'
import {DropdownDataType} from '../../core/_models'
import * as lodash from 'lodash'
import {
  getBuildingTypeList,
  getProjectByGuid,
  getProjectTypeList,
  puProjectData,
} from '../../core/_requests'
import {useNavigate, useParams} from 'react-router-dom'
import {useDispatch, useSelector} from 'react-redux'
import {
  setIsThereNonSavedForm,
  setProjectTab2,
  setProjectTab3,
} from '../../../../../common/ModalPopup/reducer'
import {toast} from 'react-toastify'
import {useAuth} from '../../../../auth'
import {useThemeMode} from '../../../../../../_metronic/partials/layout/theme-mode/ThemeModeProvider'
import {Required} from '../../../../../common/components/Required/Required'
import {CenterHelp} from '../../../../../common/components/CenterHelp/CenterHelp'
import {RadioButton} from '../../../../../common/components/RadioButton/RadioButton'
import {useIntl} from 'react-intl'

const initialNPFormValues = {
  BuildingTypeGuid: '',
  ProjectTypeGuid: '',
  DecisionDate: '',
  InstallationDate: '',
  BudgetAmountMin: '',
  BudgetAmountMax: '',
  BudgetConfirmed: true,
  LocationDuration: '',
  ProjectMotivation: '',
  ProjectGuid: '',
}

const npFormValidationSchema = Yup.object().shape({
  BuildingTypeGuid: Yup.string().required(),
  ProjectTypeGuid: Yup.string().required(),
  DecisionDate: Yup.string().required(),
  InstallationDate: Yup.string().required(),
  BudgetAmountMin: Yup.string().required(),
  // BudgetAmountMax: Yup.string().required(),
  BudgetConfirmed: Yup.bool().required(),
  LocationDuration: Yup.string().required(),
  // ProjectMotivation: Yup.string().required(),
})

type NPTab2FormPtops = {
  onSaveAndNextClick?: (responseData: any) => void
  onCancelClick?: () => void
  onBackClick?: () => void
  enabled?: boolean
}

const NPTab2Form: FC<NPTab2FormPtops> = ({
  enabled,
  onBackClick,
  onCancelClick,
  onSaveAndNextClick,
}) => {
  const {pGuid} = useParams()
  const intl = useIntl()
  const [loading, setLoading] = useState<boolean>(true)
  const [buildings, setBuildings] = useState<Array<DropdownDataType>>()
  const [projecttypes, setProjecttypes] = useState<Array<DropdownDataType>>()
  const [theProject, setTheProject] = useState<any>(null)
  const [showbq, setShowbq] = useState<boolean>(false)
  const [showCancel, setShowCancel] = useState<boolean>(false)
  const [w2go, setW2go] = useState<'tab1' | 'tab3'>('tab1')
  const dispatch = useDispatch()
  const {setAuthMessage, logout} = useAuth()
  const {mode} = useThemeMode()

  const projectData = useSelector((state: any) => state?.projectData)
  const navigate = useNavigate()
  const handleBackPress = () => {
    setW2go('tab1')
    if (isThereModif) {
      setShowbq(true)
    } else {
      navigate('/new-project/tab1' + (pGuid ? '/' + pGuid : ''), {replace: true})
    }
  }
  const validate = (values: any) => {
    let errors: any = {}
    // BuildingTypeGuid: '',
    // ProjectTypeGuid: '',
    // DecisionDate: '',
    // InstallationDate: '',
    // BudgetAmountMin: '',
    // BudgetAmountMax: '',
    // BudgetConfirmed: true,
    // LocationDuration: '',
    // ProjectMotivation: '',
    // ProjectGuid: '',
    if (values.BuildingTypeGuid || values.BuildingTypeGuid === '') {
      errors.BuildingTypeGuid = 'Batiment obligatoire'
    }
    if (values.ProjectTypeGuid || values.ProjectTypeGuid === '') {
      errors.ProjectTypeGuid = 'Type obligatoire'
    }
    if (values.DecisionDate || values.DecisionDate === '') {
      errors.DecisionDate = 'Date de décision obligatoire'
    }
    if (values.InstallationDate || values.InstallationDate === '') {
      errors.InstallationDate = "Date d'installation obligatoire"
    }
    if (values.BudgetAmountMin || values.BudgetAmountMin === '') {
      errors.BudgetAmountMin = 'Budget minimum obligatoire'
    }
    //    if (values.BudgetAmountMax || values.BudgetAmountMax === '') {
    //      errors.BudgetAmountMax = 'Budget maximum obligatoire'
    //    }
    if (values.LocationDuration || values.LocationDuration === '') {
      errors.LocationDuration = 'Durée obligatoire'
    }
    if (values.ProjectMotivation || values.ProjectMotivation === '') {
      errors.ProjectMotivation = 'Motivation est obligatoire'
    }
  }
  const npform = useFormik({
    initialValues: initialNPFormValues,
    validationSchema: npFormValidationSchema,
    validate: validate,
    onSubmit: async (values) => {
      /*if (onSaveAndNextClick) {
        onSaveAndNextClick({status: 'success'})
      }*/
      console.log('Form submit')
      npform.validateForm()

      if (npform.isValid && projectData?.tab1?.data?.Guid) {
        const projectDataResponse = await puProjectData(
          {...values, ProjectGuid: projectData?.tab1?.data?.Guid},
          (message: string) => {
            setAuthMessage(message)
            logout()
          },
          ({Message, MessageType, Toast, ToastType}) => {
            if (Message && MessageType === 'Success') {
              //
            } else if (Message && MessageType === 'Error') {
              //
            } else if (Toast && ToastType === 'Success') {
              toast(Toast, {type: 'success'})
            } else if (Toast && ToastType === 'Error') {
              toast(Toast, {type: 'error'})
            }
          }
        )
        if (
          projectDataResponse.data &&
          projectDataResponse.data.Status.Success &&
          projectDataResponse.data.data
        ) {
          dispatch(
            setProjectTab2({
              data: projectDataResponse.data.data,
              disabled: false,
              active: false,
            })
          )
          dispatch(
            setProjectTab3({
              ...projectData.tab3,
              disabled: false,
              active: true,
            })
          )
          if (!pGuid) {
            navigate('../tab3')
          }
        }
      } else if (npform.isValid && pGuid) {
        console.log('Update data')
        await puProjectData(
          {...values, ProjectGuid: pGuid},
          (message: string) => {
            setAuthMessage(message)
            logout()
          },
          ({Message, MessageType, Toast, ToastType}) => {
            // console.log('Message, MessageType, Toast, ToastType', Message, MessageType, Toast, ToastType)
            if (Message && MessageType === 'Success') {
              //
            } else if (Message && MessageType === 'Error') {
              //
            } else if (Toast && ToastType === 'Success') {
              toast(Toast, {type: 'success'})
            } else if (Toast && ToastType === 'Error') {
              toast(Toast, {type: 'error'})
            }
          }
        )
        loadData()
      }
    },
  })
  useEffect(() => {
    console.log('values', npform.values)
  }, [npform.values])
  // const handleSelectChange = (value: any) => {
  //   npform.setFieldValue('BuildingTypeGuid', value)
  // }

  const onAccessLost = (message: string) => {
    setAuthMessage(message)
    logout()
  }

  const loadData = async () => {
    console.log('projectData : ', projectData)

    if (pGuid || projectData?.tab1?.data) {
      const projectRes = await getProjectByGuid(
        {Guid: pGuid || projectData?.tab1?.data?.Guid || ''},
        (message: string) => {
          setAuthMessage(message)
          logout()
        },
        ({Message, MessageType, Toast, ToastType}) => {
          if (Message && MessageType === 'Success') {
            //
          } else if (Message && MessageType === 'Error') {
            //
          } else if (Toast && ToastType === 'Success') {
            toast(Toast, {type: 'success'})
          } else if (Toast && ToastType === 'Error') {
            toast(Toast, {type: 'error'})
          }
        }
      )
      if (projectRes?.data?.Status?.FailureReason === 'Session expired') {
        onAccessLost(projectRes?.data?.Status?.Message)
      }
      if (projectRes && projectRes?.data?.Status?.Success && projectRes?.data?.data) {
        setTheProject({
          ...projectRes?.data?.data,
          ProjectGuid: pGuid || projectData?.tab1?.data?.Guid,
          DecisionDate: projectRes?.data?.data?.DecisionDate
            ? projectRes?.data?.data?.DecisionDate?.substring(0, 10)
            : '',
          InstallationDate: projectRes?.data?.data?.InstallationDate
            ? projectRes?.data?.data?.InstallationDate?.substring(0, 10)
            : '',
        })
        npform.setValues({
          ...projectRes?.data?.data,
          ProjectGuid: pGuid || projectData?.tab1?.data?.Guid,
          DecisionDate: projectRes?.data?.data?.DecisionDate
            ? projectRes?.data?.data?.DecisionDate?.substring(0, 10)
            : '',
          InstallationDate: projectRes?.data?.data?.InstallationDate
            ? projectRes?.data?.data?.InstallationDate?.substring(0, 10)
            : '',
        })
      }
    }

    const buildingsRes = await getBuildingTypeList()
    const ptypesRes = await getProjectTypeList()

    if (
      buildingsRes &&
      buildingsRes.data &&
      buildingsRes?.data?.Status?.Success &&
      buildingsRes?.data?.data
    ) {
      setBuildings(buildingsRes?.data?.data)
    }
    if (ptypesRes && ptypesRes.data && ptypesRes?.data?.Status?.Success && ptypesRes?.data?.data) {
      setProjecttypes(ptypesRes?.data?.data)
    }

    setLoading(false)
  }

  useEffect(() => {
    if (enabled) loadData()
  }, [enabled])

  const handleBuildinsClmick = (duilding: DropdownDataType) => {
    npform.setFieldValue('BuildingTypeGuid', duilding?.Guid)
  }
  const handleProjectTypeClmick = (duilding: DropdownDataType) => {
    npform.setFieldValue('ProjectTypeGuid', duilding?.Guid)
    npform.setFieldValue('DecisionDate', '')
    npform.setFieldValue('InstallationDate', '')
  }

  const onNextWithoutSaveClick = () => {
    setW2go('tab3')
    if (isThereModif) {
      setShowbq(true)
    } else {
      navigate('/new-project/tab3' + (pGuid ? '/' + pGuid : ''))
    }
  }

  const onReset = () => {
    if (isThereModif) {
      setShowCancel(true)
    }
  }

  const onConfirmCancel = async () => {
    if (pGuid) {
      await loadData()
      setShowCancel(false)
    } else {
      npform?.setValues({...initialNPFormValues})
      setShowCancel(false)
    }
  }

  const onCancelReset = () => {
    setShowCancel(false)
  }

  let isThereModif = !lodash.isEqual(npform.values, theProject)
  useMemo(() => {
    dispatch(setIsThereNonSavedForm(isThereModif))
  }, [dispatch, isThereModif])
  const Submitted = useSelector((state: any) => state?.projectStatus?.Submitted)

  if (loading) {
    return (
      <div className='d-flex align-items-center justify-content-center'>
        <div className='spinner-border text-danger' role='status'>
          <span className='sr-only'>Loading...</span>
        </div>
      </div>
    )
  }

  return (
    <div className='px-5 py-4'>
      <form onSubmit={npform.handleSubmit}>
        <div className={'px-4 d-lg-flex d-xl-flex'}>
          <div style={{flex: 0.5}}>
            <div className='pt-4'>
              <div className='d-flex align-items-center'>
                <span className='text-gray-700 fw-bold'>
                  {intl.formatMessage({id: 'BUILDING'})}
                </span>
                <Required className='mb-2 mx-3' styles={{top: -5}} />
                {/*<CenterHelp
                  styles={{width: 32, height: 32, border: '2px solid #e74c3c', borderRadius: 100}}
                  classNames='mx-3'
                />*/}
              </div>
              <div className='d-flex py-3'>
                {buildings?.map((v) => {
                  return (
                    <RadioButton
                      handleClick={handleBuildinsClmick}
                      checked={npform.values?.BuildingTypeGuid === v.Guid}
                      data={v}
                      label={v.Name ?? ''}
                    />
                  )
                })}
              </div>
              {npform.touched.BuildingTypeGuid && npform.errors?.BuildingTypeGuid && (
                <div>
                  <span className='text-danger'>{npform.errors?.BuildingTypeGuid}</span>
                </div>
              )}
            </div>
            <div className='pt-4'>
              <div className='d-flex align-items-center'>
                <span className='text-gray-700 fw-bold'>
                  {intl.formatMessage({id: 'PROJECT_TYPE'})}
                </span>
                <Required className='mb-2 mx-3' styles={{top: -5}} />
                {/*<CenterHelp
                  styles={{width: 32, height: 32, border: '2px solid #e74c3c', borderRadius: 100}}
                  classNames='mx-3 d-flex align-items-center justify-content-center cursor-pointer'
              />*/}
              </div>
              <div className='d-flex flex-wrap gap-0 gap-sm-2 gap-md-3 flex-md-nowrap py-3'>
                {projecttypes?.map((v) => {
                  return (
                    <div
                      className={'rounded p-3 mb-2 mb-md-0 me-0 me-md-3 flex-grow-1'}
                      style={{border: '1.5px solid gray' /*flex: 0.5,*/}}
                    >
                      <RadioButton
                        classNameContainer='d-flex align-items-center cursor-pointer'
                        handleClick={handleProjectTypeClmick}
                        checked={npform.values?.ProjectTypeGuid === v.Guid}
                        data={v}
                        label={v.Name ?? ''}
                      />
                      <div>
                        {v.Code === 'AO' && (
                          <div>
                            <div className='mt-3'>
                              <FormLabel>{intl.formatMessage({id: 'P_ATTRIB_DATE'})}</FormLabel>
                              {npform.values?.ProjectTypeGuid !== v.Guid && (
                                <FormControl
                                  type='date'
                                  placeholder={intl.formatMessage({id: 'P_ATTRIB_DATE'})}
                                  disabled={npform.values?.ProjectTypeGuid !== v.Guid || Submitted}
                                  className='form-control form-control-solid'
                                  // {...npform.getFieldProps('DecisionDate')}
                                />
                              )}
                              {npform.values?.ProjectTypeGuid === v.Guid && (
                                <FormControl
                                  type='date'
                                  placeholder={intl.formatMessage({id: 'P_ATTRIB_DATE'})}
                                  disabled={npform.values?.ProjectTypeGuid !== v.Guid || Submitted}
                                  {...npform.getFieldProps('DecisionDate')}
                                  className='form-control form-control-solid'
                                />
                              )}
                            </div>
                            <div className='mt-3'>
                              <FormLabel>{intl.formatMessage({id: 'P_INSTALL_DATE'})}</FormLabel>
                              {npform.values?.ProjectTypeGuid !== v.Guid && (
                                <FormControl
                                  type='date'
                                  placeholder={intl.formatMessage({id: 'P_INSTALL_DATE'})}
                                  disabled={npform.values?.ProjectTypeGuid !== v.Guid}
                                  className='form-control form-control-solid'
                                  // {...npform.getFieldProps('InstallationDate')}
                                />
                              )}
                              {npform.values?.ProjectTypeGuid === v.Guid && (
                                <FormControl
                                  type='date'
                                  placeholder={intl.formatMessage({id: 'P_INSTALL_DATE'})}
                                  disabled={npform.values?.ProjectTypeGuid !== v.Guid}
                                  {...npform.getFieldProps('InstallationDate')}
                                  className='form-control form-control-solid'
                                />
                              )}
                            </div>
                          </div>
                        )}
                        {v.Code === 'MARKET' && (
                          <div>
                            <div className='mt-3'>
                              <FormLabel>
                                {intl.formatMessage({id: 'DECOSION_DATE_PRESTA'})}
                              </FormLabel>
                              {npform.values?.ProjectTypeGuid !== v.Guid && (
                                <FormControl
                                  type='date'
                                  placeholder={intl.formatMessage({id: 'DECOSION_DATE_PRESTA'})}
                                  disabled={npform.values?.ProjectTypeGuid !== v.Guid || Submitted}
                                  className='form-control form-control-solid'
                                  // {...npform.getFieldProps('DecisionDate')}
                                />
                              )}
                              {npform.values?.ProjectTypeGuid === v.Guid && (
                                <FormControl
                                  type='date'
                                  placeholder={intl.formatMessage({id: 'DECOSION_DATE_PRESTA'})}
                                  disabled={npform.values?.ProjectTypeGuid !== v.Guid || Submitted}
                                  {...npform.getFieldProps('DecisionDate')}
                                  className='form-control form-control-solid'
                                />
                              )}
                            </div>
                            <div className='mt-3'>
                              <FormLabel>
                                {intl.formatMessage({id: 'DATE_INSTALL_MATERIAL'})}
                              </FormLabel>
                              {npform.values?.ProjectTypeGuid !== v.Guid && (
                                <FormControl
                                  type='date'
                                  placeholder={intl.formatMessage({id: 'DATE_INSTALL_MATERIAL'})}
                                  disabled={npform.values?.ProjectTypeGuid !== v.Guid || Submitted}
                                  className='form-control form-control-solid'
                                  // {...npform.getFieldProps('InstallationDate')}
                                />
                              )}
                              {npform.values?.ProjectTypeGuid === v.Guid && (
                                <FormControl
                                  type='date'
                                  placeholder={intl.formatMessage({id: 'DATE_INSTALL_MATERIAL'})}
                                  disabled={npform.values?.ProjectTypeGuid !== v.Guid || Submitted}
                                  {...npform.getFieldProps('InstallationDate')}
                                  className='form-control form-control-solid'
                                />
                              )}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  )
                })}
              </div>
              {npform.touched.ProjectTypeGuid && npform.errors?.ProjectTypeGuid && (
                <div>
                  <span className='text-danger'>{npform.errors?.ProjectTypeGuid}</span>
                </div>
              )}
              {npform.touched.DecisionDate && npform.errors?.DecisionDate && (
                <div>
                  <span className='text-danger'>{npform.errors?.DecisionDate}</span>
                </div>
              )}
              {npform.touched.InstallationDate && npform.errors?.InstallationDate && (
                <div>
                  <span className='text-danger'>{npform.errors?.InstallationDate}</span>
                </div>
              )}
            </div>
            <div className='pt-4'>
              <div className='d-flex align-items-center'>
                <span className='text-gray-700 fw-bold'>
                  {intl.formatMessage({id: 'BUDGET_HT'})}
                </span>
                <span className='mb-2 mx-3' style={{top: -5}}>
                  <i className='fa fa-star-of-life text-danger' style={{fontSize: 10}}></i>
                </span>
                {/*<CenterHelp
                  styles={{width: 32, height: 32, border: '2px solid #e74c3c', borderRadius: 100}}
                  classNames='mx-3 d-flex align-items-center justify-content-center cursor-pointer'
              />*/}
              </div>
              <div className={'d-flex align-items-center pt-3'}>
                <div className={'d-flex align-items-center'}>
                  {/* <div className='me-3'>{intl.formatMessage({id: 'BETWEEN'})}</div>*/}
                  <FormControl
                    type='text'
                    {...npform.getFieldProps('BudgetAmountMin')}
                    className='form-control form-control-solid'
                    disabled={Submitted}
                  />
                  {/*                   
                  <div className='mx-3'>{intl.formatMessage({id: 'AND'})}</div>
                  <FormControl
                    type='text'
                    {...npform.getFieldProps('BudgetAmountMax')}
                    className='form-control form-control-solid'
                    disabled={Submitted}
                  />
*/}
                </div>

                <div className='d-flex mx-3'>
                  <RadioButton
                    classNameContainer='d-flex align-items-center cursor-pointer'
                    handleClick={() => {
                      // handleProjectTypeClmick(v)
                      npform.setFieldValue('BudgetConfirmed', true)
                    }}
                    checked={npform.values?.BudgetConfirmed === true}
                    styleInactive={{
                      border: '1px solid gray',
                      borderRadius: 100,
                      minWidth: 20,
                      minHeight: 20,
                    }}
                    styleActive={{
                      border: '6px solid #e74c3c',
                    }}
                    classNameCheckedActive='fw-bolder text-black'
                    classNameCheckedInactive='text-gray-500'
                    label={intl.formatMessage({id: 'CONFIRMED'})}
                    data={undefined}
                  />
                  <RadioButton
                    classNameContainer='d-flex align-items-center cursor-pointer'
                    handleClick={() => {
                      // handleProjectTypeClmick(v)
                      npform.setFieldValue('BudgetConfirmed', false)
                    }}
                    checked={npform.values?.BudgetConfirmed === false}
                    styleInactive={{
                      border: '1px solid gray',
                      borderRadius: 100,
                      minWidth: 20,
                      minHeight: 20,
                    }}
                    styleActive={{
                      border: '6px solid #e74c3c',
                    }}
                    classNameCheckedActive='fw-bolder text-black'
                    classNameCheckedInactive='text-gray-500'
                    label={intl.formatMessage({id: 'ESTIMATED'})}
                    data={undefined}
                  />
                </div>
              </div>
              {npform.touched.BudgetAmountMin && npform.errors?.BudgetAmountMin && (
                <div>
                  <span className='text-danger'>{npform.errors?.BudgetAmountMin}</span>
                </div>
              )}
              {/*               
              {npform.touched.BudgetAmountMax && npform.errors?.BudgetAmountMax && (
                <div>
                  <span className='text-danger'>{npform.errors?.BudgetAmountMax}</span>
                </div>
              )}
*/}
              {npform.touched.BudgetConfirmed && npform.errors?.BudgetConfirmed && (
                <div>
                  <span className='text-danger'>{npform.errors?.BudgetConfirmed}</span>
                </div>
              )}
              <div className='pt-4'>
                <div className='d-flex align-items-center'>
                  <span className='text-gray-700 fw-bold'>
                    {intl.formatMessage({id: 'LACATION_DURATION'})}
                  </span>
                  <span className='mb-2 mx-3' style={{top: -5}}>
                    <i className='fa fa-star-of-life text-danger' style={{fontSize: 10}}></i>
                  </span>
                  {/* <span className='mb-2 mx-3' style={{top: -5}}><i className='fa fa-star-of-life text-danger' style={{fontSize: 10}}></i></span>
                <span style={{width: 32, height: 32, border: '2px solid #e74c3c', borderRadius: 100}} 
                className='mx-3 d-flex align-items-center justify-content-center cursor-pointer'>
                  <i className='fa fa-question text-danger'></i>
                </span> */}
                </div>
                <div className='d-flex'>
                  <FormControl
                    type={Submitted ? 'text' : 'number'}
                    {...npform.getFieldProps('LocationDuration')}
                    style={{flex: 0.5}}
                    className='form-control form-control-solid'
                    disabled={Submitted}
                  />
                  <div style={{flex: 0.5}}></div>
                </div>
                {npform.touched.LocationDuration && npform.errors?.LocationDuration && (
                  <div>
                    <span className='text-danger'>{npform.errors?.LocationDuration}</span>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div style={{flex: 0.5}}>
            <div className='pt-4 h-100'>
              <div className='d-flex align-items-center'>
                <span className='text-gray-700 fw-bold'>{intl.formatMessage({id: 'M_A_D'})}</span>
                {/*<CenterHelp
                  styles={{width: 32, height: 32, border: '2px solid #e74c3c', borderRadius: 100}}
                  classNames='mx-3 d-flex align-items-center justify-content-center cursor-pointer'
                />*/}
              </div>
              <div className='d-flex flex-column h-75 mt-3'>
                <textarea
                  // type={'textarea'}
                  className='form-control h-100 form-control form-control-solid'
                  {...npform.getFieldProps('ProjectMotivation')}
                  disabled={Submitted}
                  // style={{flex: 0.5}}
                />
                <div style={{flex: 0.5}}>{intl.formatMessage({id: 'MOTIVATION_DEFAULT'})}</div>
              </div>
              {npform.touched.ProjectMotivation && npform.errors?.ProjectMotivation && (
                <div>
                  <span className='text-danger'>{npform.errors?.ProjectMotivation}</span>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className='d-flex justify-content-between px-4 pt-5'>
          <Button type='button' variant={'secondary'} onClick={handleBackPress}>
            <i className='ki-duotone ki-arrow-left fs-1'>
              <span className='path1'></span>
              <span className='path2'></span>
            </i>
            {intl.formatMessage({id: 'PREVIOUS'})}
          </Button>
          {/* <Button type='button' variant={'secondary'} onClick={onCancelClick}>
            {intl.formatMessage({id: 'CANCEL'})}
          </Button>
          <Button type='submit' variant={'secondary'}>
            {pGuid ? intl.formatMessage({id: 'SAVE'}) : intl.formatMessage({id: 'NEXT'})}
            {!pGuid && <i className='ki-duotone ki-arrow-right fs-1'>
              <span className='path1'></span>
              <span className='path2'></span>
            </i>}
          </Button> */}
          <div className='d-flex'>
            {pGuid && !Submitted && (
              <span className={'' + (isThereModif ? ' cursor-pointer ' : ' not-allowed ')}>
                <button
                  type='button'
                  className={
                    'btn btn-dark text-light ' +
                    (isThereModif ? ' cursor-pointer ' : ' not-allowed ')
                  }
                  // style={{backgroundColor: mode === 'dark' ? '#92929f' : '#1b1b29'}}
                  disabled={!isThereModif}
                  onClick={onReset}
                >
                  {intl.formatMessage({id: 'RESET'})}
                </button>
              </span>
            )}
            <div style={{width: 15}} />
            {pGuid && !Submitted && (
              <span className={'' + (isThereModif ? ' cursor-pointer ' : ' not-allowed ')}>
                <Button type='submit' variant={'primary'} disabled={!isThereModif}>
                  {intl.formatMessage({id: 'SAVE'})}
                </Button>
              </span>
            )}
            <div style={{width: 15}} />
            {!pGuid && (
              <span className={'' + (isThereModif ? ' cursor-pointer ' : ' not-allowed ')}>
                <Button type='submit' variant={'secondary'}>
                  {intl.formatMessage({id: 'NEXT'})}
                  <i className='ki-duotone ki-arrow-right fs-1'>
                    <span className='path1'></span>
                    <span className='path2'></span>
                  </i>
                </Button>
              </span>
            )}
            {pGuid && (
              <>
                <Button type='button' variant={'secondary'} onClick={onNextWithoutSaveClick}>
                  {intl.formatMessage({id: 'SUIVANT'})}
                  <i className='ki-duotone ki-arrow-right fs-1'>
                    <span className='path1'></span>
                    <span className='path2'></span>
                  </i>
                </Button>
              </>
            )}
          </div>
        </div>
      </form>
      <Modal show={showbq} centered>
        <div className='text-center p-5 w-100' data-bs-theme={mode}>
          <div
            className={'w-100 rounded ' + (mode === 'dark' ? ' bg-none ' : ' bg-white ')}
            data-bs-theme={mode}
          >
            <div className='d-flex align-items-center justify-content-between'>
              <div className='fw-bolder text-gray-700 py-3'>
                {intl.formatMessage({id: 'INFORMATION'})}
              </div>
              <div
                className='p-1 cursor-pointer'
                onClick={() => {
                  setShowbq(false)
                }}
              >
                <i className='fa fa-close text-danger'></i>
              </div>
            </div>
            <div className={'text-start py-3'}>
              <div>{intl.formatMessage({id: 'BEFORE_QUIT_CONFIRM_MESSAGE'})}</div>
            </div>
            <div className='d-flex align-items-center justify-content-evenly'>
              <button
                className={'btn btn-secondary'}
                onClick={() => {
                  setShowbq(false)
                }}
              >
                {intl.formatMessage({id: 'NO'})}
              </button>
              {!loading && (
                <button
                  className={'btn btn-primary'}
                  onClick={() => {
                    navigate('/new-project/' + w2go + (pGuid ? '/' + pGuid : ''))
                  }}
                >
                  {intl.formatMessage({id: 'YES'})}
                </button>
              )}
              {loading && (
                <button className={'btn btn-primary'} onClick={() => {}}>
                  {'...'}
                </button>
              )}
            </div>
          </div>
        </div>
      </Modal>
      <Modal show={showCancel} centered>
        <div className='text-center p-5 w-100' data-bs-theme={mode}>
          <div
            className={'w-100 rounded ' + (mode === 'dark' ? ' bg-none ' : ' bg-white ')}
            data-bs-theme={mode}
          >
            <div className='d-flex align-items-center justify-content-between'>
              <div className='fw-bolder text-gray-700 py-3'>
                {intl.formatMessage({id: 'INFORMATION'})}
              </div>
              <div className='p-1 cursor-pointer' onClick={onCancelReset}>
                <i className='fa fa-close text-danger'></i>
              </div>
            </div>
            <div className={'text-start py-3'}>
              <div>{intl.formatMessage({id: 'RESET_CONFIRM_MESSAGE'})}</div>
            </div>
            <div className='d-flex align-items-center justify-content-evenly'>
              <button className={'btn btn-secondary'} onClick={onCancelReset}>
                {intl.formatMessage({id: 'NO'})}
              </button>
              {!loading && (
                <button className={'btn btn-primary'} onClick={onConfirmCancel}>
                  {intl.formatMessage({id: 'YES'})}
                </button>
              )}
              {loading && (
                <button className={'btn btn-primary'} onClick={() => {}}>
                  {'...'}
                </button>
              )}
            </div>
          </div>
        </div>
      </Modal>
    </div>
  )
}

export default NPTab2Form
